// BrandIconsPDF.js
import {
  Svg,
  Path,
  Rect,
  Circle,
  Polygon,
  G,
  Line,
  TextInput,
  Font,
} from "@react-pdf/renderer";
import OpenSansBold from "../../../../../assets/fonts/Open_Sans/OpenSans-Bold.ttf";
import OpenSansRegular from "../../../../../assets/fonts/Open_Sans/OpenSans-Regular.ttf";
import RalewayRegular from "../../../../../assets/fonts/Raleway/Raleway-Regular.ttf";
import RalewayBold from "../../../../../assets/fonts/Raleway/Raleway-Bold.ttf";

Font.register({
  family: "Open Sans",
  fonts: [
    { src: OpenSansBold, fontWeight: "bold" },
    { src: OpenSansRegular, fontWeight: "normal" },
  ],
});

Font.register({
  family: "Raleway",
  fonts: [
    {
      src: RalewayRegular,
      fontWeight: "normal",
    },
    {
      src: RalewayBold,
      fontWeight: "bold",
    },
  ],
});

const toRgba = (hex, a = 1) => {
  const clean = (hex || "").replace("#", "");
  const bigint = parseInt(clean, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

const blendWithWhite = (hex, opacity = 0.1) => {
  const { r, g, b } = hexToRgb(`${hex}`);
  const blended = {
    r: Math.round((1 - opacity) * 255 + opacity * r),
    g: Math.round((1 - opacity) * 255 + opacity * g),
    b: Math.round((1 - opacity) * 255 + opacity * b),
  };
  return `rgb(${blended.r}, ${blended.g}, ${blended.b})`;
};

const hexToRgb = (hex) => {
  //   const cleanHex = hex.replace("#", "");
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
};

// Debt Consolidation Process
export const DebtConsolidationProcessIcon = ({ size, primary }) => (
  // <?xml version="1.0" encoding="UTF-8"?>
  <Svg
    width={size}
    height={size}
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 153.37 151.15"
  >
    <G>
      <Path
        d="M65.61,86.35c-1.74.18-3.49-.15-4.44-1.74-.43-.72-.22-2.19-1.39-2.46s-2.56,1.37-3.56.11c-.62-2.73,4.69-3.22,6.23-1.05,1.34,1.89,0,3.15,3.71,2.48,1.99-.36,2.58-1.34,1.78-3.29-.95-2.32-7.97-8.71-9.99-11.31-3.7-4.78,2.88-7.5,6.8-8.73l-1.19-3.69c-.03-1.98,7.85-3.32,9.56-3.48,6.47-.59,13.58.28,19.15,3.77.68,1.06-.79,2.06-.63,2.73.14.61,6.89,4.12,6.38,7.69-.22,1.5-8.9,9.94-10.17,12.02-.7.93-1.58,2.97-1.28,4.09.17.66,8.42,7.66,9.75,9.03,10.81,11.11,25.88,33.85,16.11,49.34-4.54,7.2-9.57,4.97-16.3,5.86-8.3,1.1-12.58,3.58-22.22,2.96-5.63-.36-9.87-2.69-14.5-3.4-2.47-.38-5.24.26-7.88-.22-7.3-1.33-11.36-10.87-11.91-17.49-1.31-15.89,15.36-33.07,26-43.22ZM87.67,63.25c.48-.88.47-3.7,1.77-4.8-6.72-4.15-15.57-3.02-22.97-1.48-.52.5,5.63,11.33,5.9,13.09.24,1.54-1.34,1.86-2.27.96l-3.65-8.5c-.7-.5-7.07,2.39-7.08,4.03l10.91,12.75c4.69-.7,9.62-1.06,14.31-.18l10.84-12.21c.15-.89-4.24-4.9-4.88-4.83-.25.03-.77,2.05-2.34,1.27.17.5.46.92.45,1.49-.02.88-3.95,8.97-4.7,10.23-.32.53-1.15,2.01-1.88,1.88l-1.05-1.1c1.52-3.92,3.47-7.76,5.37-11.54.36-.71,1.15-.85,1.27-1.06ZM74.78,81.66c2.52-.13,5.14,0,7.67,0,.33,0,1.23.73,1.92.42-.72-1.05-3.92-1.27-5.31-1.29-2.69-.05-5.26.63-7.9.88.57,1.24,3.02.03,3.62,0ZM101.43,145.55c5.82-.57,9.56-4.17,10.87-9.78,4.05-17.31-11.6-36.34-23.67-47.08-1.17-1.04-4.96-4.33-6.16-4.49-1.32-.18-10.94-.02-11.32.45-.44.54.19,1.59,1.08,1.72,1.53.22,4.49-1.67,7.62-1.26,2.38.31,9.63,4.47,5.77,6.61-2.91-2.65-4.31-4.6-8.68-4.05-2.92.37-5.93,2.93-8.13-.88-9.26,8.96-21.57,20.69-25.48,33.3-2.82,9.09-.5,23.58,10.78,25.03-.47-.77-1.12-1.85-.15-2.58,2.95.71,5.64,2.36,8.59,3.31,7.97,2.59,16.66,3.09,24.91,1.71,4.63-.78,8.95-3.06,13.49-3.66l.49,1.65Z"
        style="stroke-miterlimit: 10;"
        fill={blendWithWhite(primary, 1)}
        stroke={blendWithWhite(primary, 1)}
        strokeWidth={0.75}
      />
      <Path
        d="M74.78,81.66c-.6.03-3.05,1.24-3.62,0,2.64-.25,5.22-.93,7.9-.88,1.39.03,4.58.24,5.31,1.29-.69.31-1.59-.42-1.92-.42-2.53,0-5.15-.13-7.67,0Z"
        style="stroke-miterlimit: 10;"
        fill={blendWithWhite(primary, 1)}
        stroke={blendWithWhite(primary, 1)}
        strokeWidth={0.75}
      />
    </G>
    <Path
      d="M67.15,132.55v-2.47c3.31-1.68,5.63-4.94,5.63-8.64,0-1.19-.05-2.17-.25-3.46h-5.09v-3.11h4.59c-.25-1.48-.54-3.41-.54-5.33,0-5.83,4-9.63,9.48-9.63,2.57,0,4.35.59,5.38,1.24l-.99,3.26c-.89-.49-2.32-.99-4.4-.99-3.85,0-5.43,2.67-5.43,6.18,0,2.12.3,3.7.59,5.29h7.11v3.11h-6.72c.15,1.88.25,3.75-.2,5.53-.54,2.12-1.73,3.9-3.41,5.34v.1h14.72v3.61h-20.5Z"
      style="stroke-miterlimit: 10;"
      stroke={blendWithWhite(primary, 1)}
      fill="none"
    />
    <Circle
      cx="21.09"
      cy="94.79"
      r="19.09"
      style="stroke-miterlimit: 10;"
      stroke={blendWithWhite(primary, 1)}
      fill="none"
      strokeWidth={4}
    />
    <Circle
      cx="77.76"
      cy="21.09"
      r="19.09"
      style="stroke-miterlimit: 10;"
      stroke={blendWithWhite(primary, 1)}
      fill="none"
      strokeWidth={4}
    />
    <Circle
      cx="132.27"
      cy="92.98"
      r="19.09"
      style="stroke-miterlimit: 10;"
      stroke={blendWithWhite(primary, 1)}
      fill="none"
      strokeWidth={4}
    />
    <Line
      x1="77.76"
      y1="40.19"
      x2="77.76"
      y2="93.85"
      style="stroke-miterlimit: 10;"
      stroke={blendWithWhite(primary, 1)}
      fill="none"
    />
    <Line
      x1="112.96"
      y1="94.79"
      x2="85.63"
      y2="94.79"
      style="stroke-miterlimit: 10;"
      stroke={blendWithWhite(primary, 1)}
      fill="none"
    />
    <Line
      x1="66.88"
      y1="94.79"
      x2="39.55"
      y2="94.79"
      style="stroke-miterlimit: 10;"
      stroke={blendWithWhite(primary, 1)}
      fill="none"
    />
    <G style="isolation: isolate;">
      <G style="isolation: isolate;">
        <Path
          d="M73.56,28.91v-1.05c1.4-.71,2.39-2.09,2.39-3.66,0-.5-.02-.92-.1-1.47h-2.16v-1.32h1.95c-.1-.63-.23-1.44-.23-2.26,0-2.47,1.7-4.08,4.02-4.08,1.09,0,1.84.25,2.28.52l-.42,1.38c-.38-.21-.98-.42-1.86-.42-1.63,0-2.3,1.13-2.3,2.62,0,.9.13,1.57.25,2.24h3.01v1.32h-2.85c.06.8.1,1.59-.08,2.34-.23.9-.73,1.65-1.44,2.26v.04h6.24v1.53h-8.69Z"
          fill={blendWithWhite(primary, 1)}
        />
      </G>
    </G>
    <G style="isolation: isolate;">
      <G style="isolation: isolate;">
        <Path
          d="M128.68,99.89v-1.05c1.4-.71,2.39-2.09,2.39-3.66,0-.5-.02-.92-.11-1.47h-2.16v-1.32h1.95c-.1-.63-.23-1.44-.23-2.26,0-2.47,1.7-4.08,4.02-4.08,1.09,0,1.84.25,2.28.52l-.42,1.38c-.38-.21-.98-.42-1.86-.42-1.63,0-2.3,1.13-2.3,2.62,0,.9.13,1.57.25,2.24h3.01v1.32h-2.85c.06.8.1,1.59-.08,2.34-.23.9-.73,1.65-1.44,2.26v.04h6.24v1.53h-8.69Z"
          fill={blendWithWhite(primary, 1)}
        />
      </G>
    </G>
    <G style="isolation: isolate;">
      <G style="isolation: isolate;">
        <Path
          d="M16.01,101.89v-1.05c1.4-.71,2.39-2.09,2.39-3.66,0-.5-.02-.92-.1-1.47h-2.16v-1.32h1.95c-.1-.63-.23-1.44-.23-2.26,0-2.47,1.7-4.08,4.02-4.08,1.09,0,1.84.25,2.28.52l-.42,1.38c-.38-.21-.98-.42-1.86-.42-1.63,0-2.3,1.13-2.3,2.62,0,.9.13,1.57.25,2.24h3.01v1.32h-2.85c.06.8.1,1.59-.08,2.34-.23.9-.73,1.65-1.44,2.26v.04h6.24v1.53h-8.69Z"
          fill={blendWithWhite(primary, 1)}
        />
      </G>
    </G>
  </Svg>
);

//Fact Find Icon
export const FactFindIcon = ({ size, primary }) => (
  <Svg
    width={size}
    height={size}
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 103.99 78.08"
  >
    <G>
      <Path
        d="M53.29,26.64C53.29,11.93,41.36,0,26.64,0S0,11.93,0,26.64s11.93,26.64,26.64,26.64,26.64-11.93,26.64-26.64ZM43.73,51.32c.52.52,1.49.66,2.17.36s5.82-5.76,5.89-6.52c.18-1.91-1.76-2.49-3.3-1.49-.45.29-4.24,4.09-4.73,4.68-.65.79-.75,2.24-.03,2.97ZM52.68,47.86c-4.35.38-6.05,5.32-3.56,8.87,1.72,2.45,17.88,18.6,20.26,20.19,5.62,3.75,11.37-2.26,7.32-7.78-2.07-2.83-17.28-18.15-19.99-20-1.04-.71-2.76-1.38-4.04-1.27Z"
     
        fill={blendWithWhite(primary, 0.1)}
      />
      <Path
        d="M53.29,26.64c0,14.71-11.93,26.64-26.64,26.64S0,41.36,0,26.64,11.93,0,26.64,0s26.64,11.93,26.64,26.64ZM49.53,26.64c0-12.65-10.25-22.9-22.9-22.9S3.73,13.99,3.73,26.64s10.25,22.9,22.9,22.9,22.9-10.25,22.9-22.9Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M52.68,47.86c1.28-.11,2.99.56,4.04,1.27,2.71,1.85,17.92,17.18,19.99,20,4.05,5.52-1.7,11.53-7.32,7.78-2.38-1.59-18.54-17.74-20.26-20.19-2.49-3.54-.8-8.49,3.56-8.87Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M43.73,51.32c-.73-.73-.63-2.18.03-2.97.49-.59,4.28-4.38,4.73-4.68,1.54-1,3.48-.42,3.3,1.49-.07.76-5.21,6.21-5.89,6.52s-1.65.15-2.17-.36Z"
        fill={blendWithWhite(primary, 1)}
      />
    </G>
    <Path
      d="M20.5,21.66c.19.34.45.67.81.97.34,1.2.81,2.26,1.34,3.01.01.02.02.03.03.05.59.83,1.31,1.42,2.06,1.79-.73-.28-1.44-.72-2.06-1.34-.02,1.44-.2,1.68-.16,1.82.23.91,4.09,2.44,4.09,2.44h.01s.01,0,.01,0c0,0,3.86-1.52,4.09-2.44.04-.15-.14-.38-.16-1.82-.61.61-1.33,1.06-2.06,1.34.74-.37,1.47-.97,2.06-1.79.01-.02.02-.03.03-.05.54-.75,1-1.81,1.35-3.01.36-.3.62-.64.81-.97.33-.58.46-1.17.52-1.62.02-.48-.1-.88-.27-1.11-.12-.16-.26-.23-.4-.2-.02,0-.05,0-.07.01,0-.44,0-.87-.04-1.29-.04-.49-.12-.96-.24-1.41-.6-2.31-2.25-4.06-5.63-4-3.38-.07-5.03,1.69-5.63,4-.12.45-.2.93-.24,1.41-.04.42-.05.85-.04,1.29-.03,0-.05-.01-.07-.01-.14-.03-.28.04-.4.2-.17.23-.29.63-.27,1.11.06.44.19,1.03.52,1.62ZM40.55,31.74c-1.55-.17-3.1-.73-4.52-1.27-1.69-.65-3.28-1.48-4.94-2.17l-.87,4.68c-1.52-1.72-3.29-2.22-3.47-2.26,0,0-.02,0-.02,0,0,0,0,0-.01,0-.03,0-.06,0-.09,0-.03,0-.06,0-.09,0,0,0-.01,0-.01,0,0,0,0,0-.02,0-.18.05-1.95.54-3.47,2.26l-.87-4.68c-1.66.7-3.25,1.52-4.94,2.17-1.42.55-2.97,1.11-4.52,1.27-.34,1.95-.79,4.09-1.35,6.32,3.03,3.11,7.83,5.25,13.34,5.66.12,0,.24.02.35.02.27.02.54.03.82.04.25,0,.5.01.76.01s.51,0,.76-.01c.27,0,.55-.02.82-.04.12,0,.24-.01.35-.02,5.52-.41,10.32-2.55,13.34-5.66-.56-2.24-1.02-4.38-1.35-6.32ZM24.94,38.62s0,.02,0,.04c-.02.11-.03.22-.05.34,0,.03,0,.05,0,.08-.2,1.8.06,4.08.06,4.08l-.24-1.3s0,.01,0,.02l-1.56-8.38c.55-.69,1.27-1.44,2-1.95.06.3.21,1.09.29,1.37.14.47.39.81.66,1.06-.34,1.2-.85,2.42-1.15,4.64ZM28.95,39.8l-.39,2.12-.23,1.24s0-.04.01-.12c.04-.43.18-1.93.1-3.33-.26-2.94-.88-4.35-1.27-5.73.27-.25.52-.59.66-1.06.08-.28.24-1.08.29-1.37.73.52,1.45,1.26,2,1.95l-1.17,6.29s0,.01,0,.01Z"
      fill={blendWithWhite(primary, 1)}
    />
    <G>
      <Path
        d="M65.16,49.1V11.66h23.48c1.8,1.75,3.7,3.45,5.37,5.3v32.14s-28.85,0-28.85,0ZM87.36,14.14h-19.73v32.49h23.79l.12-.12v-28.31l-.12-.12h-4.06v-3.95Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M98.66.68c1.59,1.63,3.31,3.16,4.94,4.76.13.13.17.34.39.34v32.33h-3.56v-2.48h1.08V7.1h-4.18v-3.95h-19.61l-.12.12v1.74h-2.48V.68h23.52Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M93.59,5.94l5.3,5.22v32.1l-.12.12h-3.4l-.12-.12v-2.36c.37-.05.87.12,1.16-.12V12.36h-4.18v-3.95h-19.73v1.74l-.12.12h-2.24l-.12-.12v-4.22h23.55Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M71.41,40.3l15.53-.02c1.27.04,1.42,1.71.23,2.01h-15.7c-1.15-.13-1.18-1.75-.06-2Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M71.64,26.69l15.76-.02c1.15.2,1.13,1.81,0,2.02h-15.63c-1.11-.13-1.19-1.72-.13-1.99Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M71.8,35.82l15.45-.02c1.27-.03,1.37,1.87.16,2.01h-15.63c-1.18-.14-1.18-1.9.02-1.99Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M71.14,31.33c.07-.08.26-.15.36-.22l15.9-.04c1,.12,1.15,1.52.28,1.91-5.2.24-10.46.03-15.68.1-.94.11-1.46-1.09-.86-1.76Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M71.49,21.97l16-.02c1.04.15,1.02,1.82,0,1.94h-15.86c-.91-.22-.96-1.53-.13-1.92Z"
        fill={blendWithWhite(primary, 1)}
      />
    </G>
  </Svg>
);

//Illustration Icons
export const IllustrationIcon = ({ size, primary }) => (
  <Svg
    width={size}
    height={size}
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 68.54 76.56"
  >
    <G>
      <Path
        d="M19.53,76.56L7.27,25.85l31.8-7.69c3.01,1.77,6.15,3.46,9.02,5.42l10.53,43.53-39.08,9.45ZM38.15,21.93l-26.72,6.46,10.64,44.01,32.22-7.79.12-.2-9.27-38.35-.2-.12-5.5,1.33-1.29-5.34Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M49.04,0c2.69,1.69,5.52,3.2,8.26,4.84.22.13.34.4.65.33l10.59,43.8-4.82,1.17-.81-3.35,1.47-.35L55.02,7.76l-5.66,1.37-1.29-5.34-26.56,6.42-.12.2.57,2.36-3.35.81-1.42-5.87L49.04,0Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M43.9,8.78l8.89,5.34,10.51,43.48-.12.2-4.61,1.11-.2-.12-.77-3.2c.48-.19,1.22-.12,1.53-.54l-9.31-38.51-5.66,1.37-1.29-5.34-26.72,6.46.57,2.36-.12.2-3.04.73-.2-.12-1.38-5.71,31.91-7.71Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M25.11,62.59l21.03-5.11c1.73-.36,2.48,1.85.98,2.65l-21.27,5.14c-1.59.2-2.17-1.98-.73-2.68Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M20.96,44.08l21.35-5.19c1.62-.1,2.12,2.08.66,2.73l-21.17,5.12c-1.55.18-2.17-1.94-.84-2.66Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M24.17,56.39l20.92-5.08c1.71-.46,2.46,2.08.87,2.67l-21.17,5.12c-1.64.19-2.22-2.18-.62-2.71Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M21.81,50.53c.07-.13.31-.28.42-.42l21.53-5.26c1.4-.17,2.06,1.68,1.01,2.5-6.97,2.02-14.16,3.47-21.21,5.28-1.24.46-2.33-.99-1.74-2.1Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M19.21,37.74l21.66-5.27c1.46-.14,1.98,2.12.63,2.62l-21.49,5.2c-1.31,0-1.81-1.76-.81-2.56Z"
        fill={blendWithWhite(primary, 1)}
      />
    </G>
    <Rect
      x=".5"
      y="30.27"
      width="67.54"
      height="20.51"
      style="stroke-miterlimit: 10;"
      fill={blendWithWhite(primary, 0.1)}
      stroke={blendWithWhite(primary, 1)}
    />
    <G>
      <Path
        d="M14.33,40.87c-.05-1.03-.12-2.27-.11-3.19h-.03c-.25.87-.56,1.79-.93,2.81l-1.3,3.58h-.72l-1.19-3.52c-.35-1.04-.65-1.99-.85-2.87h-.02c-.02.92-.08,2.16-.14,3.27l-.2,3.17h-.91l.52-7.38h1.22l1.26,3.57c.31.91.56,1.72.75,2.49h.03c.19-.75.45-1.56.78-2.49l1.31-3.57h1.22l.46,7.38h-.93l-.19-3.24Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M23.22,40.35c0,2.54-1.54,3.89-3.43,3.89s-3.32-1.51-3.32-3.75c0-2.34,1.46-3.88,3.43-3.88s3.32,1.54,3.32,3.74ZM17.49,40.47c0,1.58.85,2.99,2.36,2.99s2.37-1.39,2.37-3.07c0-1.47-.77-3-2.36-3s-2.37,1.46-2.37,3.08Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M24.45,36.83c.48-.1,1.17-.15,1.83-.15,1.02,0,1.68.19,2.14.6.37.33.58.83.58,1.4,0,.98-.61,1.62-1.39,1.88v.03c.57.2.91.72,1.08,1.49.24,1.03.42,1.74.57,2.03h-.99c-.12-.21-.28-.84-.49-1.76-.22-1.02-.61-1.4-1.48-1.44h-.9v3.2h-.95v-7.29ZM25.41,40.2h.98c1.02,0,1.67-.56,1.67-1.4,0-.95-.69-1.37-1.7-1.38-.46,0-.79.04-.94.09v2.7Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M31.84,37.54h-2.25v-.81h5.47v.81h-2.26v6.57h-.96v-6.57Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M41.21,43.79c-.43.15-1.27.41-2.27.41-1.12,0-2.04-.29-2.76-.98-.64-.61-1.03-1.6-1.03-2.75.01-2.2,1.52-3.81,4-3.81.85,0,1.52.19,1.84.34l-.23.78c-.39-.18-.89-.32-1.63-.32-1.8,0-2.97,1.12-2.97,2.97s1.13,2.98,2.85,2.98c.62,0,1.05-.09,1.27-.2v-2.2h-1.5v-.77h2.43v3.55Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M43.86,41.8l-.77,2.32h-.99l2.51-7.38h1.15l2.52,7.38h-1.02l-.79-2.32h-2.62ZM46.28,41.05l-.72-2.13c-.16-.48-.27-.92-.38-1.35h-.02c-.11.44-.23.89-.37,1.34l-.72,2.14h2.22Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M54.82,43.79c-.43.15-1.27.41-2.27.41-1.12,0-2.04-.29-2.76-.98-.63-.61-1.03-1.6-1.03-2.75.01-2.2,1.52-3.81,4-3.81.85,0,1.52.19,1.84.34l-.23.78c-.39-.18-.89-.32-1.63-.32-1.8,0-2.97,1.12-2.97,2.97s1.13,2.98,2.85,2.98c.62,0,1.05-.09,1.27-.2v-2.2h-1.5v-.77h2.43v3.55Z"
        fill={blendWithWhite(primary, 1)}
      />
      <Path
        d="M60.1,40.66h-2.87v2.66h3.2v.8h-4.15v-7.38h3.99v.8h-3.03v2.33h2.87v.79Z"
        fill={blendWithWhite(primary, 1)}
      />
    </G>
  </Svg>
);

//Client Understanding Icon
export const ClientUnderstandingIcon = ({ size, primary }) => (
  <Svg
    width={size}
    height={size}
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 78.23 79.13"
  >
    <Path
      d="M.92,79.13c-.95-6.49-2.61-19.36,3.84-23.4,3.71-2.33,17.28-4.92,19.05-7.84s-3.6-10-4.01-13.41c-.51-4.19,1.12-5.08,1.51-7.97.77-5.75-1.08-8.94,4.37-13.8,8.18-7.29,22.14-5.5,24.5,5.93.71,3.44-.76,6.62-.59,8.49.06.64,1.73.53,2.1,1.6,2.11,5.98-5.2,15.57-3.92,18.42,4.39,5.68,18.81,5.68,22.1,11.38.28.49,1.55,4,1.55,4.26v15.25l-1.09,1.09H.92ZM47.99,32.78c-.22-.36-1.63-.38-1.95-1.32-.93-2.79,2-9.62-2.58-12.68-2.24-1.49-5.24,1.33-8.13,1.46-2.17.1-6.78-1.91-8.08-.53-2.65,3.22-.75,8.93-1.74,11.75-.34.98-1.72.98-1.92,1.31-.73,1.16,3.43,11.93,4.63,13.62,4.37,6.15,11.05,5.05,15.16-.72,1.32-1.85,5.68-11.17,4.61-12.88ZM26.71,49.36c-1.02.69-1.06,1.4-1.15,2.52-.14,1.8,4.05,22.66,4.77,23.63l10.6.4,4.96-25.39-1.38-.82c-5,5.64-13.07,5.59-17.81-.34ZM3.82,62.78c-.68,3.86.5,9.36,0,13.44h23.25l-5.12-22.5c-4.78,1.45-17.19,3.68-18.14,9.06ZM67.77,76.22v-13.44c0-.24-1.14-2.58-1.43-2.93-1.37-1.58-15.61-6.74-16.78-5.85l-5.04,22.22h23.25Z"
      fill={blendWithWhite(primary, 1)}
    />
    <Path
      d="M47.99,32.78c1.07,1.71-3.29,11.04-4.61,12.88-4.11,5.77-10.8,6.88-15.16.72-1.19-1.68-5.35-12.46-4.63-13.62.21-.33,1.58-.33,1.92-1.31.99-2.81-.92-8.52,1.74-11.75,1.3-1.39,5.91.63,8.08.53,2.89-.13,5.89-2.96,8.13-1.46,4.58,3.06,1.65,9.89,2.58,12.68.31.94,1.73.97,1.95,1.32Z"
      fill={blendWithWhite(primary, 0.1)}
    />
    <Path
      d="M67.77,76.22h-23.25l5.04-22.22c1.16-.89,15.4,4.27,16.78,5.85.3.34,1.43,2.69,1.43,2.93v13.44Z"
      fill={blendWithWhite(primary, 0.1)}
    />
    <Path
      d="M3.82,62.78c.95-5.38,13.36-7.61,18.14-9.06l5.12,22.5H3.82c.5-4.07-.68-9.58,0-13.44Z"
      fill={blendWithWhite(primary, 0.1)}
    />
    <Path
      d="M26.71,49.36c4.74,5.92,12.81,5.97,17.81.34l1.38.82-4.96,25.39-10.6-.4c-.72-.97-4.91-21.83-4.77-23.63.09-1.12.13-1.83,1.15-2.52Z"
      fill={blendWithWhite(primary, 0.1)}
    />
    <Path
      d="M74.02,4.68c1.73,1.84,3.18,4.81,3.54,7.31,1.17,8.26-4.03,9.06-5.97,15.76-.35,1.19.16,2.7-1.35,2.85.44,3.32-.47,7.87-4.2,8.85-5.81,1.53-8.62-3.77-7.95-8.85l-.92-.35c-.21-1.54-.47-3.11-1.03-4.56-1.75-4.49-5.32-5.17-5.51-11.14-.4-12.24,14.93-18.89,23.4-9.86ZM69.93,28.92c.59-7.06,6.78-8.32,6.28-15.89-.95-14.6-22.98-14.67-24.08.01-.51,6.78,3.95,7.78,5.72,13.3.27.84.49,1.7.53,2.59l11.55-.02ZM68.77,30.44h-9.22v1.78h9.22v-1.78ZM68.77,33.71h-8.47c-.1,0-.32-.52-.74.15l.3,1.33h8.62l.3-1.49ZM67.58,36.68h-6.84c1.65,2.03,5.24,2.13,6.84,0Z"
      style="stroke-miterlimit: 10;"
      fill={blendWithWhite(primary, 1)}
      stroke={blendWithWhite(primary, 1)}
    />
    <Path
      d="M69.93,28.92l-11.55.02c-.04-.89-.26-1.75-.53-2.59-1.77-5.52-6.23-6.52-5.72-13.3,1.11-14.68,23.13-14.62,24.08-.01.49,7.56-5.69,8.83-6.28,15.89ZM65.76,4.62h-3.19s-.79,2.04-.79,2.04l-2.21-.76-1.75,1.86.85,2.02c-.04.5-2.09.42-2.36,1.79-.49,2.46.8,2.18,2.34,3.26-1.58,1.97-.49,2.65,1.11,3.97l2.03-.84.95,2.09,3.03-.05.64-2.04,2.37.76c1.89-1.58,2.05-2,1.2-4.32l2.04-.79-.1-2.8-1.94-.59c-.26-1.1.94-1.58.44-2.66-.1-.21-1.65-1.71-1.83-1.74l-2.18.84-.64-2.04Z"
      style="stroke-miterlimit: 10;"
      fill={blendWithWhite(primary, 1)}
      stroke={blendWithWhite(primary, 0.1)}
    />
    <Path
      d="M65.76,4.62l.64,2.04,2.18-.84c.18.03,1.73,1.54,1.83,1.74.5,1.08-.7,1.55-.44,2.66l1.94.59.1,2.8-2.04.79c.85,2.33.69,2.75-1.2,4.32l-2.37-.76-.64,2.04-3.03.05-.95-2.09-2.03.84c-1.6-1.33-2.69-2-1.11-3.97-1.54-1.08-2.83-.8-2.34-3.26.27-1.37,2.33-1.28,2.36-1.79l-.85-2.02,1.75-1.86,2.21.76.79-2.04h3.19ZM70.52,11.75c-1.13.13-2.55-1.41-2.2-2.39.15-.43,1.24-1.15.46-1.66-.68-.44-1.3.4-1.95.45-2.01.15-1.93-2.35-2.36-2.37-1.39.64-1.18,2.68-3.2,2.33-.49-.09-1.13-.94-1.56-.25s.56,1.28.32,2.38c-.28,1.3-1.04,1.35-2.22,1.52l-.05.99c2.08.28,3.18,1.89,1.54,3.59l.56.61c.55.27,1.66-.95,3.05-.17.68.38.22,2.29,2,1.79-.24-1.14.78-2.17,1.91-2.08.71.06,1.59,1.15,2.12,0,.24-.51-.84-.94-.64-1.78.24-1.06,1.13-1.79,2.22-1.82v-1.12Z"
      style="stroke-miterlimit: 10;"
      stroke={blendWithWhite(primary, 0.1)}
      fill={blendWithWhite(primary, 0.1)}
    />
    <Path
      d="M70.52,11.75v1.12c-1.09.03-1.98.76-2.22,1.82-.2.84.88,1.27.64,1.78-.53,1.15-1.41.05-2.12,0-1.13-.09-2.15.94-1.91,2.08-1.78.5-1.32-1.41-2-1.79-1.39-.78-2.5.44-3.05.17l-.56-.61c1.64-1.69.54-3.31-1.54-3.59l.05-.99c1.18-.17,1.94-.22,2.22-1.52.24-1.1-.77-1.67-.32-2.38s1.07.17,1.56.25c2.02.35,1.81-1.68,3.2-2.33.43.02.34,2.52,2.36,2.37.65-.05,1.27-.89,1.95-.45.78.51-.3,1.23-.46,1.66-.35.99,1.07,2.53,2.2,2.39ZM67.88,12.31c0-2.03-1.64-3.67-3.67-3.67s-3.67,1.64-3.67,3.67,1.64,3.67,3.67,3.67,3.67-1.64,3.67-3.67Z"
      style="stroke-miterlimit: 10;"
      stroke={blendWithWhite(primary, 1)}
      fill={blendWithWhite(primary, 0.1)}
    />
    <Path
      d="M67.88,12.31c0,2.03-1.64,3.67-3.67,3.67s-3.67-1.64-3.67-3.67,1.64-3.67,3.67-3.67,3.67,1.64,3.67,3.67ZM66.45,12.28c0-1.25-1.01-2.26-2.26-2.26s-2.26,1.01-2.26,2.26,1.01,2.26,2.26,2.26,2.26-1.01,2.26-2.26Z"
      style="stroke-miterlimit: 10;"
      fill={blendWithWhite(primary, 1)}
      stroke={blendWithWhite(primary, 1)}
    />
  </Svg>
);

// Additional Information Icon
export const AdditionalInformationIcon = ({ size, primary }) => (
  <Svg
    width={size}
    height={size}
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 79.19 48.48"
  >
    <G id="hW13Qu">
      <Path
        d="M30.69,15.73h-5.62c-.14,0-.42.44-.41.66.44,2.44.22,5,.01,7.44l6.28-1.43.24-4.18c.51-.08,1.27-.66,1.71-.65.65.01,8.12,7.5,9.21,8.54l-.19,1.79c-1.34.93-8.25,8.34-9.02,8.4-.19.02-1.96-.96-1.96-1.1v-3.79c-1.84.31-3.45,1.1-4.51,2.68-.16.24-.98,1.79-.98,1.89v11.63h-9.14l.16-11.76c-.7-2.5-2.88-4.05-5.38-4.43v3.79l-2.1,1.05L.11,27.89l-.11-1.97c1.45-.86,8.22-8.3,9.13-8.35,2.8-.15,1.84,3.14,1.97,4.95,2.21-.02,4.28.75,6.27,1.57v-8.36h-6.01l9.76-10.17,9.57,10.17ZM8.75,21.22c-.46-.11-.52.19-.79.39-1.82,1.39-3.52,3.82-5.48,5.23l5.88,5.61c.59.11.36-.26.39-.65.07-.91-.05-1.84,0-2.75,2.27-.13,4.58.2,6.51,1.46l2.11,1.68v-5.49c-2.73-1.37-5.54-2.07-8.62-1.83v-3.66ZM19.07,45.25h4.05v-9.54c0-.29.95-2.31,1.2-2.72,1.82-3.01,5.6-4.24,8.99-3.94.19.92.01,1.89.04,2.76.01.38-.26.73.35.63l5.88-5.61c-1.82-1.47-3.69-3.85-5.48-5.23-.26-.2-.33-.51-.78-.39l.26,3.65c-5.32-.45-10.6,1.73-13.2,6.53-2.23,4.13-1.28,8.98-1.62,13.47l.31.38Z"
        fill={blendWithWhite(primary, 1)}
      />
    </G>
    <G id="zRPRG1">
      <G>
        <Path
          d="M33.69,48.48c.1-2.79-.03-5.69.7-8.4s1.71-3.64,4.06-4.91c2.83-1.53,6.16-2.23,9.19-3.3.07.01.17.95.19,1.1.93,4.95,3.44,7.9,7.83,10.21.26.14.64.39.93.32.36-.1,1.23-.66,1.6-.88,2.11-1.26,3.94-2.77,5.2-4.91,1.04-1.78,1.55-3.8,1.83-5.83,2.1.67,4.24,1.28,6.32,2.03,1.94.7,4.93,2.02,6.03,3.83,1.26,2.09,1.48,5.33,1.58,7.74l.05,3h-45.5Z"
          fill={blendWithWhite(primary, 1)}
        />
        <Path
          d="M57.13,0c3.1.22,5.86,1.21,8.03,3.49,2.04,2.15,2.35,5.08,2.23,7.93l-.34,3.12.08.08c.72-.15,1.3.73,1.36,1.37.13,1.53-.2,2.93-1.07,4.19-.49.7-.6.5-.57,1.52.08,2.81,1.17,5.62,3.69,7.07.26.15.62.27.86.43.05.03.09,0,.06.11-.63.13-1.24.38-1.86.54-2.47.63-5.16.73-7.32-.8-.4-.28-.72-.63-1.1-.92-1.16.88-2.66,1.86-4.13,2.11s-3.1-.59-4.32-1.35c-.17-.1-.94-.7-1.03-.7-.16-.02-.43.35-.56.46-2.02,1.67-4.28,1.89-6.8,1.45-1.01-.18-2.01-.49-2.97-.85.54-.24,1.07-.49,1.55-.83,2.42-1.69,3.09-4.75,3.11-7.55-1.28-1.34-1.79-3.01-1.64-4.86.06-.7.62-1.38,1.34-1.43.07-.05.05-.3.05-.4-.04-.63-.2-1.33-.25-1.98-.13-1.84-.13-3.94.43-5.71,1.28-4.04,5.68-6.25,9.68-6.46h1.49ZM65.56,12.09c-.69.04-1.4-.23-2.03-.47-1.88-.73-3.71-1.81-5.18-3.19-.74-.7-1.35-1.46-1.93-2.28-.94,1.41-2.12,2.56-3.51,3.53s-3.16,1.89-4.79,2.3c-.19.05-.59.02-.7.19-.09.15-.06.7-.05.9.11,1.35.5,2.75.69,4.09l-.92-1.59c-.6-.7-1.21,0-1.3.68-.24,1.78.75,2.72,1.59,4.03,1.01,1.58,1.6,2.97,2.88,4.46s4.31,4.22,6.44,4.01,5.23-3.2,6.49-4.86c.9-1.18,1.41-2.41,2.19-3.61s1.51-1.75,1.61-3.3c.07-1.06-.6-2.52-1.53-1.13l-.7,1.3c.29-1.68.66-3.35.74-5.06Z"
          fill={blendWithWhite(primary, 1)}
        />
      </G>
    </G>
  </Svg>
);
